import { Department } from './Department'

export const getDepartmentLabel = (department: Department): string => {
    const groupName = department.departmentGroup?.name

    return `${groupName ? `${groupName} - ` : ''}${department.name}`
}